import ServiceBase from 'services/ServiceBase'

class registerStatisticsApiClient extends ServiceBase {
  get = (date) => this.request({
    path: `/statistics/registers?date=${date}`,
  })
}

export default registerStatisticsApiClient
